<div
  class="wsu-empty"
  [class.wsu-empty--blue]="accent === 'blue'"
  role="status"
  aria-live="polite"
  [attr.data-testid]="testId"
>
  <div class="wsu-empty__icon" aria-hidden="true">
    <svg *ngIf="icon === 'shop'" viewBox="0 0 24 24" fill="none">
      <path
        d="M3.5 20.5V9.2L12 3.5l8.5 5.7v11.3"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 20.5v-6h6v6"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 10.5h1.5M15 10.5h1.5M7.5 13.5h1.5M15 13.5h1.5"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
    <svg *ngIf="icon === 'staff'" viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="8" r="3.2" stroke="currentColor" stroke-width="1.8" />
      <path
        d="M3.5 18.5c.6-3 2.8-4.5 5.5-4.5s4.9 1.5 5.5 4.5"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
      <circle cx="17" cy="9" r="2.4" stroke="currentColor" stroke-width="1.8" />
      <path
        d="M20.5 18c-.4-2.2-1.8-3.4-3.5-3.4"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
    <svg *ngIf="icon === 'tunnel'" viewBox="0 0 24 24" fill="none">
      <rect
        x="3.5"
        y="6.5"
        width="17"
        height="11"
        rx="2"
        stroke="currentColor"
        stroke-width="1.8"
      />
      <path d="M8 12h8M8 15h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </svg>
  </div>
  <h2 class="wsu-empty__title" [attr.data-testid]="testId + '-title'">{{ title }}</h2>
  <p class="wsu-empty__text">{{ text }}</p>
  <div class="wsu-empty__hint">
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <circle cx="10" cy="10" r="8" fill="none" stroke="currentColor" stroke-width="1.6" />
      <path d="M10 9v5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      <circle cx="10" cy="6.5" r="0.9" fill="currentColor" />
    </svg>
    <span>{{ hint }}</span>
  </div>
</div>
